import React from 'react'
import { Box, Container, Grid, Text, Button } from '@mantine/core'
import ImgHeaderCourse from '../../../assets/img/ImgHeaderCourse.png'
import classes from '../../../pages/Bootcamp/Bootcamp.module.css'
import { useViewportSize } from '@mantine/hooks'

const CourseHeader = ({ handleScroll }) => {
  const { width } = useViewportSize()
  return (
    <Box className={classes.headerSection} py={width > 768 ? 120 : 80} style={{ backgroundImage: `url(${ImgHeaderCourse}?dim=500x500)`}}>
      <Container fluid className={classes.section}>
        <Box className={classes.innerHeader}>
          <Box className={classes.contentHeader}>
            <Grid justify="start" align="center">
              <Grid.Col span={{ base: 12, lg: 7 }}>
                <Box className={classes.paddingPage}> 
                  <Text className={classes.titleHeader} mb={16}>Bersama Membangun Kompetensi untuk Masa Depan Berkelanjutan</Text>
                  <Text className={classes.captionHeader} mb={24}>Melalui video e-learning interaktif, kami mengajak Anda untuk meningkatkan keterampilan teknis dan interpersonal. Belajar dari para ahli dan tingkatkan kompetensi Anda untuk masa depan yang lebih hijau</Text>
                  <Button color="indigo.9" className={classes.buttonHeader} fz={16} radius="md" onClick={handleScroll}>
                    <Text p={10} fw="bold">Pilih Course</Text>
                  </Button>
                </Box>
              </Grid.Col>
            </Grid>
          </Box>
        </Box>
      </Container>
    </Box>
  )
}

export default CourseHeader